import { type WorkerClient } from './worker-client';

// This is a temporary workaround for circular dependency
// Workspace slice refers to app to ge the worker instance
// And since app.ts reference redux store we have a circle dep
// FIXME: remove this when we get rid of the app.ts class
let instance: WorkerClient | null = null;
export function setWorker(worker: WorkerClient | null) {
    instance = worker;
}

export function getWorker() {
    if (!instance) {
        throw new Error('instance null');
    }
    return instance;
}
